import { useTranslation } from 'react-i18next';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { TextSmRg } from '@/UI/AppTypography/AppTypography';
import { FlexCenVer, FlexCol } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { getIteratorValues } from '@/utils/iterator.utils';
import { useFlowView } from '@/components/Recipe/FlowContext';
import type { PrecedingIteratorData } from '@/hooks/usePrecedingIterators';

export const IteratorSection = ({
  iteratorsData,
  isOpen,
  itemWidth = '85px',
}: {
  iteratorsData: PrecedingIteratorData[] | null;
  isOpen: boolean;
  itemWidth?: string;
}) => {
  if (!iteratorsData || !isOpen) return null;
  return (
    <FlexCol style={{ width: '100%', gap: '4px' }}>
      {iteratorsData.map((iteratorData) => (
        <IteratorItem
          key={`${iteratorData.iteratorNode.id}-${iteratorData.inputKey}-${iteratorData.nodeId}`}
          iteratorData={iteratorData}
          itemWidth={itemWidth}
        />
      ))}
    </FlexCol>
  );
};

const IteratorItem = ({ iteratorData, itemWidth }: { iteratorData: PrecedingIteratorData; itemWidth?: string }) => {
  const { t } = useTranslation();
  const flowView = useFlowView();
  const {
    iteratorNode: { id: iteratorNodeId, data },
  } = iteratorData;
  const values = getIteratorValues(iteratorNodeId, data, (id) => flowView.listSelectorOptions(id));
  return (
    <FlexCenVer sx={{ width: '100%', justifyContent: 'space-between', gap: 1 }}>
      <TextSmRg color={token.textSecondary}>{data.name}</TextSmRg>
      <FlexCenVer
        sx={{
          height: '24px',
          width: itemWidth,
          backgroundColor: token.bgTransparent,
          borderRadius: '4px',
          px: 1,
          py: 0.5,
        }}
      >
        <TextSmRg>{t(I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES, { count: values.length })}</TextSmRg>
      </FlexCenVer>
    </FlexCenVer>
  );
};
